import { analyticsClient, connectBaseApi, createRpcQuery } from "@racoon/api";

const analyticsGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getJobMetricSeries: createRpcQuery(build, analyticsClient, "getJobMetricSeries", {
      providesTags: ["Order"],
    }),
    getDriverActivitySeries: createRpcQuery(build, analyticsClient, "getDriverActivitySeries", {
      providesTags: ["Order", "Employee"],
    }),
    getRouteCategorySeries: createRpcQuery(build, analyticsClient, "getRouteCategorySeries", {
      providesTags: ["Order"],
    }),
    getServiceProviderStats: createRpcQuery(build, analyticsClient, "getServiceProviderStats", {
      providesTags: ["Order", "Truck"],
    }),
    getFuelConsumptionSeries: createRpcQuery(build, analyticsClient, "getFuelConsumptionSeries", {
      providesTags: ["Truck"],
    }),
    getEngineHoursSeries: createRpcQuery(build, analyticsClient, "getEngineHoursSeries", {
      providesTags: ["Truck", "Employee"],
    }),
    getShiftUsage: createRpcQuery(build, analyticsClient, "getShiftUsage", {
      // Shift mutations invalidate the LIST id, so a bare "DriverOnShift" tag never matches.
      providesTags: [{ type: "DriverOnShift", id: "LIST" }],
    }),
    getTruckLatestReadings: createRpcQuery(build, analyticsClient, "getTruckLatestReadings", {
      providesTags: [
        { type: "Truck", id: "LIST" },
        { type: "DriverOnShift", id: "LIST" },
      ],
    }),
    getShiftEngineHours: createRpcQuery(build, analyticsClient, "getShiftEngineHours", {
      providesTags: ["DriverOnShift"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetJobMetricSeriesQuery,
  useGetDriverActivitySeriesQuery,
  useGetRouteCategorySeriesQuery,
  useGetServiceProviderStatsQuery,
  useGetFuelConsumptionSeriesQuery,
  useGetEngineHoursSeriesQuery,
  useGetShiftUsageQuery,
  useGetTruckLatestReadingsQuery,
  useGetShiftEngineHoursQuery,
} = analyticsGrpc;
